/* eslint-disable no-restricted-globals */

import { CHECK_EMAIL_REMINDER_PARAM } from "src/components/collapsible-header/CollapsibleHeader";
import { pushReroll, reroll, setParam } from "./utils";

type OffersParams = {
  upid?: string;
  claimedByEmail?: string;
  promoCode?: string;
  enrollmentResult?: string;
  forceReroll?: boolean;
};

function isNoomPremium() {
  return location.pathname.startsWith("/noom-premium");
}
function isOffers() {
  return (
    location.pathname.startsWith("/add-ons/") ||
    location.pathname.startsWith("/en/add-ons/") ||
    location.pathname.startsWith("/offers/") ||
    location.pathname.startsWith("/en/offers/") ||
    location.pathname.startsWith("/in-app-offers/")
  );
}

export const linkTo = {
  noomPremium({
    upid,
    claimedByEmail,
    promoCode,
    enrollmentResult,
    forceReroll,
  }: OffersParams) {
    const queryParams = new URLSearchParams(location.search);

    setParam(queryParams, "upid", upid);
    setParam(queryParams, "claimedByEmail", claimedByEmail);
    setParam(queryParams, "promoCode", promoCode);
    setParam(queryParams, "enrollmentResult", enrollmentResult);
    setParam(queryParams, "rerollMerEx", forceReroll);

    return `/noom-premium/${`${queryParams}` ? `?${queryParams}` : ""}`;
  },
  addOns({ upid, claimedByEmail, enrollmentResult }: OffersParams) {
    const queryParams = new URLSearchParams(location.search);

    setParam(queryParams, "upid", upid);
    setParam(queryParams, "claimedByEmail", claimedByEmail);
    setParam(queryParams, "enrollmentResult", enrollmentResult);

    return `/add-ons${`${queryParams}` ? `?${queryParams}` : ""}`;
  },
  addOnConfirmation(params: OffersParams) {
    return `${linkTo.addOns(params)}#/confirmation`;
  },
  limitedOffer(productId: string) {
    return `${linkTo.addOns({})}#/limitedOffer/${productId}`;
  },
};

export default {
  noomPremium(params: OffersParams) {
    reroll(linkTo.noomPremium(params));
  },
  noomPremiumCustomPlans(params: OffersParams) {
    pushReroll(`${linkTo.noomPremium(params)}#/customPlans`, isNoomPremium);
  },
  addOns({
    upid,
    claimedByEmail,
    enrollmentResult,
    forceReroll,
    showEmailReminder,
  }: OffersParams & { showEmailReminder: boolean }) {
    const queryParams = new URLSearchParams(location.search);

    setParam(queryParams, "upid", upid);
    setParam(queryParams, "claimedByEmail", claimedByEmail);
    setParam(queryParams, "rerollMerEx", forceReroll);
    setParam(queryParams, "enrollmentResult", enrollmentResult);
    setParam(queryParams, CHECK_EMAIL_REMINDER_PARAM, showEmailReminder);

    reroll(`/add-ons`, queryParams);
  },
  addOnConfirmation(params: OffersParams) {
    pushReroll(linkTo.addOnConfirmation(params), isOffers);
  },
  limitedOffer(productId: string) {
    pushReroll(linkTo.limitedOffer(productId), isOffers);
  },

  fastForwardTrial({
    upid,
    forceReroll,
    showEmailReminder,
  }: {
    upid?: string;
    forceReroll?: boolean;
    showEmailReminder?: boolean;
  }) {
    const queryParams = new URLSearchParams(location.search);

    setParam(queryParams, "upid", upid);
    setParam(queryParams, "rerollMerEx", forceReroll);
    setParam(queryParams, CHECK_EMAIL_REMINDER_PARAM, showEmailReminder);

    reroll(`/fast-forward-trial/`, queryParams);
  },
};
